module.exports = __webpack_public_path__ + "static/media/miniwave-policie-travel.0e0c8b5f.svg";